<!-- 
  新建 装配单特殊字段
  prop: 
    item: 绑定对象
    form: form表单数据对象
  emit: 
    showProduct: 打开关联商品弹窗
 -->

<template>
  <div class="redundant">
    <!-- 仓库 -->
    <template v-if="item.attr === 'outWarehouseId'||item.attr === 'intoWarehouseId'">
      <remote-select
        module="warehouse"
        :item="item"
        :form="form"
        @emitObj="warehouseId">
      </remote-select>
    </template>
    <!-- 负责人 -->
    <template v-if="item.attr === 'managerId'">
      <v-manager
        :item="item"
        :form="form">
      </v-manager>
    </template>
    <!-- 产品 -->
<!--     <template v-if="item.attr === 'outProducts'">
      <div class="products" v-if="form.outWarehouseId">
        <div class="v-area">
          <template v-if="form[item.attr] && form[item.attr].length">{{form[item.attr] | productLen}}</template>
          <template v-else>暂无关联产品</template>
        </div>
        <span class="add-btn" @click="emitParent('out')">选择</span>
      </div>
      <span v-else>请选择出库仓库</span>
    </template>
    <template v-if="item.attr === 'inProducts'">
      <div class="products">
        <div class="v-area">
          <template v-if="form[item.attr] && form[item.attr].length">{{form[item.attr] | productLen}}</template>
          <template v-else>暂无关联产品</template>
        </div>
        <span class="add-btn" @click="emitParent('in')">选择</span>
      </div>
    </template> -->
  </div>
</template>

<script>
import remoteSelect from '../remote-select'
import vManager from '../manager'
import { mapActions } from 'vuex'

export default {
  props: ['item', 'form'],
  methods: {
    ...mapActions([
      'setWarehouseId'
    ]),
    emitParent (type) {
      this.$emit('showProduct', type)
    },
    // 切换出库仓库时，清空出库,并将仓库ID存入vuex
    warehouseId (obj) {
      if (this.item.attr === 'outWarehouseId') {
        this.setWarehouseId(obj.id)
        this.form.outProducts = []
        this.$emit('getchangeHouse', this.item.attr)
      }
      if (this.item.attr === 'intoWarehouseId') {
        this.$emit('getchangeIntoWare', this.item.attr)
      }
    }
  },
  filters: {
    productLen (arr) {
      let num = 0
      arr.forEach((item) => {
        num += item.num
      })
      num = Number(num.toFixed(5))
      return `${arr.length}种产品${num}件`
    }
  },
  components: {
    remoteSelect,
    vManager
  }
}
</script>
<style lang="less" scoped>
  @import '../../../assets/less/fieldtype-products.less';
</style>


// WEBPACK FOOTER //
// index.vue?67f2d218